<template>
  <v-form v-model="valid" ref="mainForm">
    <CaseACocherLive code="decla1" v-model="sas.consentement" :live="liveSasStage(6509)" />
  </v-form>
</template>

<script>
import StepFormWithValidation from "@/mixins/StepFormWithValidation"
export default {
  mixins: [StepFormWithValidation],
  props: {
    sas: { type: Object }
  },
  computed: {
    sasStage() {
      return this.sas.sasStage
    }
  },
  methods: {
    liveSasStage(cle) {
      return { endpoint: "sas-stages", cle: cle, fileId: this.sasStage.id }
    }
  }
}
</script>